import React from 'react'

const Step = ({
  current,
  max,
  text,
  style,
  accent,
  accentColor = 'white',
}) => (
  <div
    style={{
      ...style,
    }}
  >
    <div
      style={{
        color: accentColor,
        fontSize: '20px',
        fontWeight: 700,
        marginBottom: '.5rem',
        display: 'flex',
        flexDisplay: 'row',
        alignContent: 'center',
        justifyContent: 'flex-start',
      }}
    >
      {current}
      <span style={{ fontSize: '30px', fontWeight: 600 }}>&#47;</span>
      {max}
    </div>
    <div style={{ fontWeight: 600 }}>
      {text}&nbsp;{accent && (
        <span style={{ color: accentColor }}>{accent}</span>
      )}
    </div>
  </div>
)

export default Step



// WEBPACK FOOTER //
// ./src/components/application/step.js